

// FontAwesome 5 - https://fontawesome.com/
import "@fortawesome/fontawesome-pro/css/all.css";

import Swiper from 'swiper/swiper-bundle.js';
import 'swiper/swiper-bundle.css';

import 'lightgallery/src/sass/lightgallery.scss';

import 'bootstrap';

import basicNavigation from './header/header';
import inlineSVG from './utilities/convert-svg-to-html';
import 'lightgallery';
import 'lg-thumbnail';
import 'lg-video';

import { TimelineMax, TweenMax, TimelineLite, Back, Power4 } from "gsap/all.js";
import { gsap } from 'gsap';

import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

import Instafeed from 'instafeed.js';
import sidebarNav from "./header/sidebar-nav";

window.Instafeed = Instafeed;

$(function () {

    var swiper = new Swiper(".slider", {
        loop: true,
        effect: "fade",
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
    });

    sidebarNav();

    basicNavigation();

    inlineSVG('.navbar-logo, .footer-logo, .admin-logo');


    $('.lightgallery').lightGallery({
        selector: '.lightgallery-item',
        thumbnail: true
    });

    var speed = 1;

    gsap.to(".heading1", {
        scrollTrigger: ".heading1",
        opacity: 1,
        x: 0,
        duration: speed
    });

    gsap.to(".heading2", {
        scrollTrigger: ".heading2",
        opacity: 1,
        x: 0,
        duration: speed
    });

    gsap.to(".heading3", {
        scrollTrigger: ".heading3",
        opacity: 1,
        x: 0,
        duration: speed
    });

    gsap.to(".intro", {
        scrollTrigger: ".intro",
        opacity: 1,
        y: 0,
        duration: speed
    });

    AOS.init({
        // Global settings:
        disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
    });
});

$(window).scroll(function () {
    var t = $(window).scrollTop();
    (t = t / 15),
        $(".brand-circle").css({ "-moz-transform": "rotate(" + t + "deg)", "-webkit-transform": "rotate(" + t + "deg)", "-o-transform": "rotate(" + t + "deg)", "-ms-transform": "rotate(" + t + "deg)", transform: "rotate(" + t + "deg)" });
});
